import React from 'react';
import { chinaData } from '../../data/chinaData';
import MapComponent from './MapComponent';

const ChinaMap = ({ currentLanguage="en", setCurrentLanguage }) => {
  return (
    <MapComponent
      currentLanguage={currentLanguage}
      setCurrentLanguage={setCurrentLanguage}
      data={chinaData}
      mapName="China"
    />
  );
};

export default ChinaMap;